import { useEffect, useState } from "react";
import Icon from "./Icon";
import { navigation, siteDetails } from "../siteContent";

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [activeSection, setActiveSection] = useState("home");

  useEffect(() => {
    const handleEscape = (event) => {
      if (event.key === "Escape") {
        setMenuOpen(false);
      }
    };

    document.addEventListener("keydown", handleEscape);
    return () => document.removeEventListener("keydown", handleEscape);
  }, []);

  useEffect(() => {
    if (!("IntersectionObserver" in window)) {
      return undefined;
    }

    const sections = navigation
      .map(({ section }) => document.getElementById(section))
      .filter(Boolean);
    const observer = new IntersectionObserver(
      (entries) => {
        const visible = entries
          .filter((entry) => entry.isIntersecting)
          .sort((a, b) => b.intersectionRatio - a.intersectionRatio)[0];

        if (visible) {
          setActiveSection(visible.target.id);
        }
      },
      { rootMargin: "-25% 0px -60%", threshold: [0.05, 0.25, 0.5] }
    );

    sections.forEach((section) => observer.observe(section));
    return () => observer.disconnect();
  }, []);

  const closeMenu = () => setMenuOpen(false);

  return (
    <header className="site-header">
      <div className="utility-bar">
        <div className="container utility-bar__inner">
          <p>Care and nursing support in Southport</p>
          <div className="utility-bar__links">
            <a href={siteDetails.phoneHref}>
              <Icon name="phone" size={17} />
              <span>{siteDetails.phoneDisplay}</span>
            </a>
            <a href={`mailto:${siteDetails.email}`}>
              <Icon name="mail" size={17} />
              <span>{siteDetails.email}</span>
            </a>
          </div>
        </div>
      </div>

      <div className="nav-shell">
        <div className="container nav-shell__inner">
          <a
            aria-label="Ascot Lodge Nursing Home, home"
            className="brand"
            href="#home"
            onClick={closeMenu}
          >
            <span aria-hidden="true" className="brand__mark">
              AL
            </span>
            <span className="brand__text">
              <strong>Ascot Lodge</strong>
              <small>Nursing Home</small>
            </span>
          </a>

          <button
            aria-controls="primary-navigation"
            aria-expanded={menuOpen}
            aria-label={menuOpen ? "Close navigation menu" : "Open navigation menu"}
            className="menu-toggle"
            onClick={() => setMenuOpen((open) => !open)}
            type="button"
          >
            <Icon name={menuOpen ? "close" : "menu"} size={27} />
          </button>

          <nav
            aria-label="Primary navigation"
            className={`primary-nav${menuOpen ? " primary-nav--open" : ""}`}
            id="primary-navigation"
          >
            <ul>
              {navigation.map(({ label, href, section }) => (
                <li key={section}>
                  <a
                    aria-current={activeSection === section ? "location" : undefined}
                    className={activeSection === section ? "is-active" : undefined}
                    href={href}
                    onClick={closeMenu}
                  >
                    {label}
                  </a>
                </li>
              ))}
            </ul>
            <a className="button button--small" href="#contact" onClick={closeMenu}>
              Arrange a visit
            </a>
          </nav>
        </div>
      </div>
    </header>
  );
};

export default Navbar;
